// ms_MY language file
// Generated from Feishu Bitable
// Total entries: 565

export default{
    "game_diamond": {
        "title": "Game Diamond Info",
        "title0_title": "How to Get Game Diamonds",
        "title0": {
            "txt1": "1. Earn them through specific tasks or events.",
            "txt2": "2. Cannot be purchased with top-up."
        },
        "title1_title": "Game Diamond Usage",
        "title1": {
            "txt1": "1. Only used for games.",
            "txt2": "2. In-game, Game Diamonds work the same as regular diamonds and can be used directly. Diamonds won with Game Diamonds are regular diamonds.",
            "txt3": "3. Game Diamonds are used first.",
            "txt4": "4. Can be combined with diamonds. E.g., if you have 200 Game Diamonds and 800 Diamonds, using 1000 will consume both."
        },
        "title2_title": "Game Diamond Validity",
        "title2": {
            "txt1": "1. Valid for a limited time and will be reclaimed after expiration."
        }
    },
    "guanxi_gift_rule_title": "Gift Descriptions",
    "guanxi_gift_rule_1": "After sending a relationship gift, the recipient can choose whether to form a relationship with you. Only one relationship can exist between two people at a time.",
    "guanxi_gift_rule_2": "Each person can have up to 3 relationships, and the relationship types can be the same.",
    "guanxi_gift_rule_3": "You can end a relationship 24 hours after forming it. After ending a relationship, you can form a new one after another 24 hours.",
    "not_exist": "Not found",
    "mbti_intro_title": "MBTI Descriptions",
    "mbti_intro_pers": "Personality Traits",
    "mbti_intro_love": "Romantic Traits",
    "mbti_intro_istj_pers": "Inspector Personality",
    "mbti_intro_istj_feature": "Serious, quiet, detail-oriented, and precise, they prefer an orderly and structured life. Reliable and responsible, they follow rules and traditions.",
    "mbti_intro_istj_love": "In love, ISTJs are loyal, stable partners. They take relationships seriously, focusing on commitment and responsibility, showing their care through actions rather than words, needing time to form deep connections.",
    "mbti_intro_isfj_pers": "Caregiver Personality",
    "mbti_intro_isfj_feature": "Gentle, kind, and empathetic, they are attentive to others' needs and patient. Detail-oriented, they are great listeners and supporters.",
    "mbti_intro_isfj_love": "In relationships, ISFJs are deeply caring, attentive to their partner’s life details, and create a cozy and warm atmosphere. Often traditional, they may take time to commit but are very loyal once they do.",
    "mbti_intro_infj_pers": "Architect Personality",
    "mbti_intro_infj_feature": "Insightful and creative, with a deep understanding of humanity and the future. They have rich inner lives and are thoughtful and analytical.",
    "mbti_intro_infj_love": "INFJs look for mental and emotional connection with partners, valuing deep conversations. They have high ideals in love and, when in love, are focused and devoted.",
    "mbti_intro_intj_pers": "Commander Personality",
    "mbti_intro_intj_feature": "Logical, calm, and confident with strong analytical and decision-making skills, they value knowledge and wisdom and pursue goals tenaciously.",
    "mbti_intro_intj_love": "In relationships, INTJs approach love rationally, valuing shared beliefs and goals. Though reserved with emotions, they show their care through thoughtful actions.",
    "mbti_intro_istp_pers": "Craftsman Personality",
    "mbti_intro_istp_feature": "Practical, observant, and analytical, they enjoy hands-on tasks and solving practical problems, especially in mechanical or technical areas.",
    "mbti_intro_istp_love": "ISTPs are spontaneous and free-spirited in relationships, enjoying the present moment with their partners, and sharing life’s pleasures without much restriction.",
    "mbti_intro_isfp_pers": "Artist Personality",
    "mbti_intro_isfp_feature": "Sensitive, gentle, and artistic, they prioritize emotional and sensory experiences, often expressing themselves through creative forms.",
    "mbti_intro_isfp_love": "In relationships, ISFPs are romantic and considerate, skilled at creating a charming atmosphere, and often delight their partners with surprises. They can be emotional and need a partner who understands and supports them.",
    "mbti_intro_infp_pers": "Mediator Personality",
    "mbti_intro_infp_feature": "Idealistic, kind, and empathetic, they have rich inner lives and a strong understanding of human nature, valuing harmony and beauty.",
    "mbti_intro_infp_love": "INFPs invest deeply in relationships, seeking strong emotional connections. They value emotional exchanges and share a hopeful view of love.",
    "mbti_intro_intp_pers": "Logician Personality",
    "mbti_intro_intp_feature": "Analytical and curious, they have a strong desire for knowledge, exploring unknown areas in pursuit of truth.",
    "mbti_intro_intp_love": "In relationships, INTPs are logical, focusing on intellectual and emotional compatibility. While they may be reserved in expressing feelings, they use discussions to foster mutual understanding.",
    "mbti_intro_estp_pers": "Entrepreneur Personality",
    "mbti_intro_estp_feature": "Energetic, outgoing, and adventurous, they enjoy social interactions and risk-taking, seizing opportunities actively.",
    "mbti_intro_estp_love": "In relationships, ESTPs are vibrant and passionate, loving to explore new experiences with their partners. They are straightforward, openly expressing their thoughts and feelings.",
    "mbti_intro_esfp_pers": "Performer Personality",
    "mbti_intro_esfp_feature": "Outgoing, optimistic, and expressive, they enjoy socializing and entertainment, bringing energy and enthusiasm.",
    "mbti_intro_esfp_love": "In love, ESFPs are lively partners who enjoy shared social activities, emphasizing present feelings and experiences, bringing joy and excitement to their partners.",
    "mbti_intro_enfp_pers": "Campaigner Personality",
    "mbti_intro_enfp_feature": "Creative, energetic, and warm, they love engaging with others and deeply understand others’ emotions.",
    "mbti_intro_enfp_love": "ENFPs are like the sunshine in relationships, bringing warmth and joy to their partners. Full of romance, they actively express their love and look forward to creating beautiful memories together.",
    "mbti_intro_entp_pers": "Debater Personality",
    "mbti_intro_entp_feature": "Smart, witty, and inquisitive, they enjoy debating and exploring new ideas and subjects.",
    "mbti_intro_entp_love": "ENTPs engage in deep discussions and debates with partners, enjoying challenge and intellectual growth in love. Often playful, they bring humor to the relationship.",
    "mbti_intro_estj_pers": "Executive Personality",
    "mbti_intro_estj_feature": "Practical, decisive, and confident, with strong organization and leadership skills, they prioritize efficiency and results.",
    "mbti_intro_estj_love": "In love, ESTJs are assertive and determined, actively pursuing their interests and planning for the future. They show affection through practical support and actions.",
    "mbti_intro_esfj_pers": "Consul Personality",
    "mbti_intro_esfj_feature": "Friendly and warm, they are social and care for others, valuing tradition and family bonds.",
    "mbti_intro_esfj_love": "ESFJs are attentive and nurturing partners, creating a harmonious, warm romantic environment. Often traditional, they appreciate familiar dating customs and family approval.",
    "mbti_intro_enfj_pers": "Protagonist Personality",
    "mbti_intro_enfj_feature": "Charismatic and confident, they connect easily and communicate well, understanding and guiding others effectively.",
    "mbti_intro_enfj_love": "ENFJs are enthusiastic and romantic partners, openly expressing their love and creating a warm atmosphere. They value emotional exchange and aim to form a deep bond with their partners.",
    "mbti_intro_entj_pers": "Executive Personality",
    "mbti_intro_entj_feature": "Logical, confident, and driven, with strong leadership and decision-making abilities, they value excellence and success, holding high standards for themselves and others.",
    "mbti_intro_entj_love": "In love, ENTJs are goal-oriented, choosing like-minded partners who support mutual growth. They prioritize competence and shared ambitions, deepening relationships through shared goals.",
    "expressProposalWall": "Proposal Wall Rule",
    "expressHowTo": "How to get on the Proposal Wall",
    "expressSend": "Send the proposal gift to your lover and your text of expressing love will be shown on the Proposal Wall.",
    "expressSend1": "1.Tap \"Proposal Now\", you can jump to the party and select the user to send your love words.",
    "expressSend2": "2.Select the gift and enter the words you want to say to him/her on the card.",
    "expressSend3": "3.Tap to send the gift and your proposal card will be shown on the wall.",
    "expressDifferent": "Different Types of Proposal Gifts",
    "expressWeHave": "We have 4 types of Proposal Gifts as follows.",
    "expressWeHave1": "1.Basic Proposal Gift Card: Simple color background.",
    "expressWeHave2": "2.Decoration Proposal Gift Card: Decorative colorful background.",
    "expressWeHave3": "3.Luxury Proposal Gift Card: Decorative background in luxury effect.",
    "expressWeHave4": "4.True Love Proposal Gift Card: Decorative background in luxury effect, and with fancy server-wide notification bar.",
    "expressProposal": "Proposal Card Display Range",
    "expressProposal1": "1.Proposal Wall in room.(Tap the bar above the proposal gifts)",
    "expressProposal2": "2.Proposal Wall Next to the Moment page.",
    "diamondDrop1": "1. When a user sends gifts totaling over 50,000 diamonds in a room (lucky gifts are calculated at 0.1 times their value), a diamond chest drops that anyone in the room can open to grab diamonds.",
    "diamondDrop2": "2. Each chest has a 1-minute countdown before it can be opened.",
    "diamondDrop3": "3. Diamonds in each chest are limited; once the countdown ends, you can’t claim diamonds from that chest anymore.",
    "diamondDrop4": "4. After the chest closes, you can click to see how many diamonds you snagged from it.",
    "baoxaingxianding": "Treasure Gift Limit",
    "cancelAccount": {
        "accountRecoveryContent": "During the recovery period, you can log back in using your previous method and choose to recovery your account. Once recoveried, you’ll regain all your account messages, levels and diamond.",
        "accountRecoveryTitle": "Account Recovery:",
        "confirmCancellation": "Are you sure you want to delete?",
        "convalescenceContent": "After submitting a deletion request, your account will be temporarily disabled for 30 days. During this time, all your account information, levels, and diamonds will be retained, allowing for a seamless recovery if you change your mind.",
        "convalescenceTitle": "Recovery Period:",
        "finalContent": "If you do not choose to recovery your account by the end of the recovery period (31 days from the deletion request), your account and all associated data will be permanently deleted. Please note that once deleted, your account and data cannot be recovered.",
        "finalTitle": "Final Deletion:",
        "reserveContent": "During the recovery period, we will protect your account data to ensure it is not lost or damaged.",
        "reserveTitle": "Data Retention:",
        "statementContent": "Deletion Request: After you submit an account deletion request, your account will enter a 30-day “recovery period.” During this time, you can choose to recovery your account at any point. If you are part of a agency, account deletion will not be possible.",
        "statementTitle": "Account Deletion Notice:",
        "userContent": "Thank you for using our services. We understand that you may sometimes need to deletion your account. To ensure your decision is well-considered and to provide an opportunity for reconsideration, we outline the account deletion process and related terms here.",
        "userTitle": "Dear User:"
    },
    "Countdown": "Countdown",
    "Endactivity": "Event Ended",
    "eventDetails": "Event Details",
    "eventGifts": "Event Gifts",
    "eventList": "Event Leaderboard",
    "eventReward": "Event Rewards",
    "eventRewards": {
        "player": "Daily Active Players",
        "proportion": "Prize Return Rate",
        "title": "Event Prizes",
        "txt1": "1. Data from the previous day is calculated daily at 00:00 (UTC+8).",
        "txt2": "2. Prizes are awarded based on the number of participants and the actual diamonds spent in the room (user bets minus user winnings).",
        "txt3": "3. Data for the previous week is calculated every Monday at 00:00 (UTC+8), and rewards are distributed within 3 days.",
        "txt4": "4. Prize Return Rate:",
        "txt5": "5. Definition of Active Player: A player who bets more than 1,000 diamonds in a day."
    },
    "EventRules": "Event Rules",
    "Eventtime": "Event Time",
    "guild": {
        "guild_certification01": "Agency Verification",
        "guild_certification02": "Welcome Agency",
        "guild_certification03": "Recruitment Requirements",
        "guild_certification04": [
            "Completed 10 signed anchors and settled in within one week",
            "Able to provide the agency leader’s ID and other real-name documents",
            "Provide a agency profile, team introduction, anchor information, anchor earnings rules, etc."
        ],
        "guild_certification05": "If you meet the above requirements, send your information to the official email: billionairepte@gmail.com Once approved, a staff member will contact you.",
        "guild_certification06": "Copied to clipboard",
        "guild_certification07": "Contact for Inquiry",
        "guild_certification08": "Copy",
        "guild_certification09": "Membership Information",
        "guild_certification10": [
            {
                "title": "1. Membership Rules",
                "value": [
                    "Applicants must agree with the agency leader to initiate a membership request on the platform. Once approved by the leader, they become a signed anchor, contributing to the agency."
                ]
            },
            {
                "title": "2. Resignation Rules",
                "value": [
                    "To leave the agency after joining, the anchor needs to agree with the agency leader. Click “Leave Agency” on the agency profile page. The agency leader must click “Agree to Leave” and then the member will exit the agency.",
                    "After the withdrawal is successful, you can apply to join other agency."
                ]
            }
        ],
        "guild_certification11": "Agency Information",
        "guild_certification12": [
            {
                "title": "Agency Earnings",
                "value": [
                    "Users and anchors in family rooms receive gifts, generating agency contributions.",
                    "Boss attacks occur in family rooms.",
                    "Anchors signed with the agency create CP rooms, and receiving gifts generates agency contributions. (Unsigned anchor cannot create CP rooms and generate family contributions after joining the family.)"
                ]
            }
        ],
        "InvitationCodeTitle": "Invitation Code",
        "invite_rules_intriduction": "Invitation Rules",
        "invite_rules_intriduction_content": [
            "Anchors can apply to join your agency and become a anchors by entering the invitation code during registration.",
            "Anchors who did not enter an invitation code during registration can apply to join your family through the family page, and then apply to become a anchor."
        ]
    },
    "legend": {
        "title": "Legendary February"
    },
    "officialMember": "Official Staff",
    "prettyNumber": {
        "text": "Ⅰ. Special ID Collection",
        "text1": "After reaching Noble Level 3 or higher, you can claim a Special ID corresponding to your level.",
        "text2": "Higher-level nobles can claim a lower-level Special ID. For example, a Noble 6 can claim a Level 3 Special ID.",
        "text3": "When your noble status expires, the Special ID also becomes unavailable. You need to reactivate your noble to continue using the Special ID.",
        "text5": "Once you claim a Special ID, you cannot exchange it for another number of the same or lower level.",
        "text6": "If you achieve a higher noble level while using a Special ID, you can immediately switch to a higher-level Special ID, and the original ID will return to the store.",
        "text7": "For example, a Noble 4 user who initially claims a Noble 4 Special ID and then upgrades to Noble 6 cannot switch to a Noble 4 or lower Special ID, but can immediately claim a Noble 6 Special ID.",
        "title": "Explanation",
        "title1": "Ⅱ. Special ID Expiration",
        "title2": "Ⅲ. Special ID Replacement"
    },
    "reception": {
        "reception01": "Gift Leaderboard Explanation",
        "reception02": [
            {
                "title": "What is the Room Gift Leaderboard?",
                "value": [
                    "The Room Gift Leaderboard is a real-time ranking of gifts received in the room",
                    "Room gift count = Diamond gift count"
                ]
            },
            {
                "title": "How is the Room Gift Leaderboard ranked?",
                "value": [
                    "The ranking is determined based on the total income of all rooms, calculated comprehensively",
                    "Hourly Leaderboard: Resets every hour at UMT+8",
                    "Daily Leaderboard: Resets at 00:00 UMT+8 every day"
                ]
            },
            {
                "title": "Top 1 on the Hourly Leaderboard is broadcasted server-wide",
                "value": [
                    "The top 1 room on the hourly gift leaderboard is announced across all server rooms"
                ]
            }
        ]
    },
    "roomParty": {
        "back": "Return",
        "event_rule": "<p>1. Duration Leaderboard: Tracks the total time users spend in the room's all mic positions during the event. The top 3 contributors in the top 3 rooms will receive rewards.</p><p>2. Generosity Leaderboard: Tracks the total number of diamonds received in the room during the event. The top 3 diamond spenders in the top 3 rooms will receive rewards.</p><p>3. This event is a weekly cycle event, with the leaderboard resetting and recalculating each week.</p>",
        "last_week": "Last Week",
        "last_week_rank": "Last Week's Leaderboard Details",
        "reward": "Rewards",
        "rich_rank": "Room Gift Leaderboard",
        "rule": "Rules",
        "rule_reward": "Rules & Rewards",
        "time_rank": "Duration Leaderboard",
        "title": "Family Room",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_1_name": "Frame for 14 days",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/mount/thunder_armor.png?t=1666610955",
        "top1_pictures_2_name": "Effects for 14 days",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_3_name": "Frame for 14 days",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/avatarFrame/patrician/platinum_gentleman.png",
        "top1_pictures_4_name": "Frame for 7 days",
        "top2": "TOP2",
        "top3": "TOP3"
    },
    "TopUpRewards": "TopUp Rewards",
    "treasure_chest": {
        "title": "Treasure Chest Gift Instructions",
        "value1": "There are three types of treasure chests: Wooden, Silver, and Gold.",
        "value2": "When you open a treasure chest, you will randomly receive a gift from the chest and send it out.",
        "value3": "The sender earns experience points based on diamonds spent, while the recipient receives Coins and charm points based on the gift value from the chest.",
        "value4": "Wooden Chest, priced at 1500 diamonds, contains the following gifts:",
        "value5": "Silver Chest, priced at 7500 diamonds, contains the following gifts:",
        "value6": "Gold Chest, priced at 25000 diamonds, contains the following gifts:",
        "value7": "Treasure chest gifts are for entertainment and social interaction only. Any actions affecting fairness or exploiting product bugs will be prohibited. If detected, the platform will ban the account and reserves the right to pursue legal action."
    },
    "treasure_name": {
        "name1": "Wooden Chest",
        "name2": "Silver Chest",
        "name3": "Gold Chest",
        "name4": "Probability"
    },
    "Value": "Value:",
    "Webname": {
        "addUid": "Add UID",
        "balance": "Balance:",
        "Confirm": "Confirm",
        "err_uid": "Invalid UID, please re-enter",
        "lang": "Select Language",
        "Query": "Search",
        "recharge": "Recharge Center",
        "Recharge": "Top-Up",
        "self": "Channel",
        "uid": "Change UID",
        "uuserName": "Nickname:",
        "Withdrawal": "Withdraw"
    },
    "Weekly_Cp": {
        "7days": "7 days",
        "back": "Back",
        "countdown": "Countdown to this week",
        "day": "Days",
        "diamonds": "https://image.pocketliveapp.com/image/activity/New%20Folder/diamonds.png",
        "event_rule": "<p>Notes</p><p>1. All rewards will be credited to your account within 3-5 business days after the event ends.</p><p>2. The leaderboard calculates the diamonds spent on sending event gifts to other users. 1 diamond = 1 CP point, and the top 3 CP pairs with the highest CP points will receive event rewards.</p><p>3. The event ends every Monday at 00:00 (UTC+8), and the values for the previous week are settled.</p><p>4. Only 10% of the diamonds spent on lucky gifts will be counted.</p>",
        "gift": "Event Gifts",
        "hour": "Hour",
        "last_week": "Last week",
        "last_week_rank": "Last week's list",
        "minute": "Minute",
        "pocketcoins": "https://image.pocketliveapp.com/image/activity/New%20Folder/coins.png",
        "reward": "Rewards",
        "rule": "Rules",
        "rule_reward": "Rules & Rewards",
        "seconds": "Seconds",
        "title": "Soulmate",
        "top1": "TOP1",
        "top1_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top1_pictures_1_name": "Weekly Star Avatar Frame",
        "top1_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top1_pictures_2_name": "Best Support Avatar Frame",
        "top1_pictures_3": "https://image.pocketliveapp.com/image/goods/2011_cloth_female.png?t=1678879041",
        "top1_pictures_34_name": "Weekly Star Outfit",
        "top1_pictures_4": "https://image.pocketliveapp.com/image/goods/2010_suit_male.png?t=1678879038",
        "top2": "TOP2",
        "top2_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top2_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top3": "TOP3",
        "top3_pictures_1": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_female.png?t=1679315785",
        "top3_pictures_2": "https://image.pocketliveapp.com/image/goods/avatarFrame/personal/avatarFrame_weekly_male.png?t=1679315767",
        "top46": "TOP 4-6",
        "top710": "TOP7-10"
    },
    "Withdrawal": "Withdrawal Instructions",
    "withdrawalInstructions": {
        "text1": "The withdrawal feature is currently available in select countries only.",
        "text2": "The time it takes for withdrawals to be processed may vary depending on the channel.",
        "text3": "The actual amount received may be slightly lower than the displayed amount due to exchange rate fluctuations and fees.",
        "text4": "You can only withdraw once per day.",
        "text5": "If you encounter any issues, please contact us."
    },
    "withdrawalLogin": {
        "accountId": "Pix account ID",
        "accountIdTips": "",
        "accountIdtsa": "Pix account ID cannot be empty",
        "accountType": "Pix account type",
        "code": "Verification code:",
        "Confirm": "Confirm",
        "documentId": "Personal ID number",
        "documentIdTips": "",
        "documentIdtsa": "ID type cannot be empty",
        "documentType": "ID type",
        "getAccount": "Get account",
        "getUserId": "Please enter user ID",
        "incorrectAccount": "Incorrect account",
        "login": "Login",
        "loginSuccessful": "Login successful",
        "name": "Pix username",
        "nameTips": "",
        "nametsa": "Length must be between 5 and 100 characters",
        "officialGroup": "If you have any questions, please contact our official support.",
        "pocket": "Pocket Coin balance",
        "Pocket": "Insufficient Pocket Coin balance",
        "Send": "Send",
        "text": "Verification code will be sent within the app",
        "title": "Earnings withdrawal",
        "title2": "Withdrawal details",
        "user_id": "Account ID:",
        "Whatsapp": "Incorrect Whatsapp account",
        "WhatsappTips": "",
        "applicationTime": "Request Date",
        "amount": "Withdrawal Amount",
        "success": "Success",
        "applicationSuccess": "Request Submitted"
    },
    "top1AnchorRewards": "Top 1 Anchor Rewards",
    "top2_3AnchorRewards": "Top 2-3 Anchor Rewards",
    "top4_10AnchorRewards": "Top 4-10 Anchor Rewards",
    "top1Icon7day": "Avatar Frame*7D",
    "top1_2Icon7day": "Entrance Effect*7D",
    "top3Icon7day": "Avatar Frame*7D",
    "top1VIPRewards": "Top 1 VIP Rewards",
    "top2_3VIPRewards": "Top 2-3 VIP Rewards",
    "top4_10VIPRewards": "Top 4-10 VIP Rewards",
    "relastionship": {
        "des": [
            "",
            "1. After sending a relationship gift, the other party can choose whether to establish a relationship with you. Only one type of relationship can exist between two people.",
            "2. Within 7 calendar days (UTC+3) after establishing a relationship, intimacy will not decay. After this protection period, if intimacy does not increase by 50 points in a day, it will decay by 10% at 00:00 the next day (minimum decay is 1). When intimacy reaches 0, the relationship will be unbound at 00:00 the next day. If intimacy doesn’t increase by 50 points for 10 consecutive days, the relationship will automatically end at 00:00.",
            "3. You can end the relationship 24 hours after forming it. After ending it, you can re-establish a relationship 24 hours later.",
            "4. Each person has 3 relationship slots by default. You can spend diamonds to buy more, each slot costs 99,999 diamonds, and you can purchase up to 10. You can also increase your slots by raising your VIP level.",
            "VIP Level",
            "Total expandable relationship slots"
        ]
    },
    "gift_album_des1": "Menghantar hadiah di atas dapat membantunya menerangi Album Mingguan - \"Jelajah Dunia\" dan mendapat ganjaran.",
    "gift_album_des2": "Menghantar hadiah di atas dapat membantunya menerangi Album Kekal - \"Tumpuan Hati\" dan mendapat ganjaran.",
    "gift_album_des3": "Menghantar hadiah di atas dapat membantunya menerangi Album Kekal - \"Pelindung SVIP\" dan mendapat ganjaran.",
    "gift_album_des4": "Menghantar hadiah di atas dapat membantunya menerangi Album Kekal - \"Perkahwinan Impian\" dan mendapat ganjaran.",
    "gift_album_des5": "Pergi ke [Profil] - [Dinding Hadiah] - [Album] untuk melihat butiran",
    "gift_album_des8": "Menghantar hadiah di atas boleh membantunya mengaktifkan Koleksi Kekal – 'Pesta Hari Jadi' dan menerima ganjaran.",
    "gift_album_des7": "Menghantar hadiah di atas dapat membantunya menerangi Album Kekal - \"Bintang Bilik\" dan mendapat ganjaran.",
    "gift_harifata": "Burj Khalifa",
    "gift_sailing_hotel": "Burj Al Arab",
    "gift_mosque": "Masjidil Haram",
    "gift_abatta": "Menara Abate",
    "gift_sphinx": "Sphinx",
    "svip_gift_1": "SVIP1",
    "svip_gift_2": "SVIP2",
    "svip_gift_3": "SVIP3",
    "svip_gift_4": "SVIP4",
    "svip_gift_5": "SVIP5",
    "svip_gift_6": "SVIP6",
    "gift_conf_lv1": "Cinta Degupan Jantung",
    "gift_conf_lv2": "Cinta Terpukul",
    "gift_conf_lv3": "Cinta Tanpa Batas",
    "gift_conf_lv4": "Tiada siapa melainkan awak",
    "gift_habibi": "Habibi",
    "gift_bestie": "Bestie",
    "gift_couple": "berpasangan",
    "gift_confidant": "Yakin",
    "weding_gift_kiss": "Ciuman",
    "weding_gift_ring": "Cincin",
    "weding_gift_proposal": "Lamaran",
    "weding_gift_castle": "Istana",
    "weding_gift_wedding_dress": "Gaun pengantin",
    "weding_gift_wedding": "Perkahwinan",
    "gift_album_des6": "Rules",
    "guild_can_with": "Tersedia",
    "guild_with_ing": "Dalam proses",
    "guild_self_withdraw": "Pengeluaran sendiri",
    "guild_transfer_to_leader": "Pindah ke Ketua Agensi",
    "guild_salary_to_reseller": "Pindah ke Penjual Semula",
    "guild_convert_to_diamond": "Tukar kepada Berlian",
    "guild_platform_settlement": "Penyelesaian platform",
    "guild_withdrawal_records": "Sejarah pengeluaran",
    "guild_current_withdrawable_pcoin": "Syiling tersedia",
    "guild_transfer_pcoin_amount": "Amaun untuk dipindahkan",
    "guild_all": "Semua",
    "guild_read_before_withdraw": "Baca sebelum pengeluaran:",
    "guild_withdraw_note_1": "Hantar",
    "guild_withdraw_note_2": "Syiling boleh keluar tidak mencukupi",
    "guild_min_withdraw_amount": "Sahkan penghantaran?",
    "guild_withdraw_note_4": "Batal",
    "guild_appeal_to_platform": "Sahkan",
    "guild_submit_application": "Kaedah pengeluaran",
    "guild_withdraw_below_min": "Pengeluaran ketua",
    "guild_confirm_submit_application": "Masa permohonan",
    "guild_freeze_notice": "Masa pemprosesan",
    "guild_communicate_with_leader": "Sebab ditolak",
    "guild_cancel": "Amaun dipulangkan",
    "guild_confirm": "Menunggu",
    "guild_withdrawal_method": "Selesai",
    "guild_leader_withdraw": "Ditolak",
    "guild_status_timeout_rejected": "Ditolak automatik (masa tamat)",
    "guild_status_unknown": "Tiada",
    "guild_status_platform_review": "Disemak Platform",
    "guild_status_guild_review": "Disemak Agensi",
    "guild_status_timeout_rejected_2": "Masa Tamat (Dikembalikan)",
    "guild_status_platform_rejected": "Ditolak Platform",
    "guild_status_guild_leader_approval": "Dialihkan ke Agensi dlm <span>{n}</span> jam",
    "guild_apply_time": "Hanya 3 bulan terakhir",
    "guild_process_time": "Ada soalan tentang pengeluaran?",
    "guild_rejection_reason": "Hubungi sokongan",
    "guild_amount_refunded": "Penjual semula disahkan",
    "guild_status_pending": "Untuk penjual semula sahaja",
    "guild_status_completed": "Tersedia",
    "guild_status_rejected": "Amaun pindahan",
    "guild_show_last_3_months": "Anggaran masuk",
    "guild_withdrawal_question": "Berjaya",
    "guild_contact_customer_service": "Tukar kepada Berlian",
    "guild_certified_reseller": "Syiling tersedia untuk ditukar",
    "guild_not_reseller_cannot_transfer": "Tukar",
    "guild_current_withdrawable": "Ditukar",
    "guild_transfer_amount": "Syiling diselesaikan",
    "guild_estimated_arrival": "Permohonan dihantar",
    "guild_read_before_operation": "1. Sila sahkan butiran bayaran luar talian dengan penjual semula terlebih dahulu",
    "guild_transfer_note_1": "2. Pindahan hanya ke penjual semula",
    "guild_transfer_note_2": "Sahkan pindahan",
    "guild_confirm_transfer": "Sahkan penghantaran?",
    "guild_confirm_submit_transfer": "{n} syiling akan ditolak",
    "guild_deduct_pcoin_receive_diamond": "Sila selaraskan butiran bayaran dengan penjual semula",
    "guild_communicate_with_reseller": "Transaksi berjaya",
    "guild_operation_success": "Tukar kepada Berlian",
    "guild_exchange_diamond": "Syiling tersedia untuk ditukar",
    "guild_current_exchangeable_pcoin": "Tukar",
    "guild_exchange": "Penukaran berjaya",
    "guild_exchange_success": "Syiling menunggu penyelesaian",
    "guild_settlement_pcoin_amount": "1. Sila sahkan kaedah pengeluaran dengan pasukan Operasi terlebih dahulu",
    "guild_settlement_note_1": "2. Bayaran akan diproses Isnin depan",
    "guild_settlement_note_2": "3. Minimum pengeluaran: {n} syiling",
    "guild_settlement_min_amount": "Permohonan dihantar",
    "guild_application_submitted": "{n} syiling akan ditolak",
    "guild_deduct_pcoin": "Sila selaraskan butiran bayaran dengan pasukan Operasi",
    "guild_user_not": "Pengguna tidak ditemui",
    "guild_please_enter_amount": "Masukkan jumlah",
    "guild_insufficient_balance": "Baki tidak mencukupi",
    "guild_please_enter_reseller_uid": "Masukkan UID RESELLER",
    "guild_please_search_reseller_first": "Sila cari RESELLER terlebih dahulu",
    "guild_select_hand": "Pilih tindakan",
    "guild_ci_hand": "1. Tindakan ini akan menghantar permohonan kepada Ketua Guild,",
    "guild_offline_transfer_funds": "dan bayaran akan dibuat secara luar talian oleh ketua",
    "guild_ci_hand_2": "2. Sila sahkan kaedah bayaran dengan ketua terlebih dahulu (kad bank / USDT, dll.)",
    "guild_ci_hand_3": "3. Jumlah pengeluaran minimum ialah {n} Coins",
    "guild_ci_hand_4": "4. Jika ketua mengesahkan bayaran tetapi anda belum menerimanya, simpan rekod chat dan",
    "guild_ci_hand_5": "hantar aduan kepada platform",
    "guild_ci_hand_6": "Sistem akan membekukan {n} Coins sehingga diproses oleh ketua",
    "guild_ci_hand_7": "Sila sahkan saluran pengeluaran dengan ketua; bayaran dibuat luar talian",
    "guild_tips_1": "Coins boleh dikeluarkan di bawah minimum",
    "guild_contact_service": "Sila hubungi pasukan operasi untuk urusan bayaran",
    "guild_reseller_tips": "Syiling anda kini menjadi berlian pengguna lain. Sila hubungi mereka mengenai bayaran.",
    "gift_collection_detail_permanent_birthday": "Parti Hari Jadi",
    "gift_collection_detail_permanent_roomstar": "Bintang Bilik",
    "gift_holy_sword": "Pedang Suci",
    "gift_volcano": "Gunung Berapi",
    "gift_emperor_come_world": "Maharaja Eropah Datang ke Dunia",
    "gift_castle_of_love": "Istana Cinta",
    "gift_Immortal_god_war": "Dewa Perang Abadi",
    "gift_king_of_gods": "Raja Tuhan",
    "birthday_gift_cybergift": "Hadiah Siber",
    "birthday_gift_wish": "Harapan Lampu",
    "birthday_gift_cake": "Kek Emas",
    "birthday_gift_lion": "Berkat Singa",
    "birthday_gift_biggift": "Hadiah Mewah",
    "guild_page_fee": "Caj $2 setiap pengeluaran",
    "guild_page_saudi": "Arab Saudi",
    "guild_page_morocco": "Maghribi",
    "guild_page_bank": "Bank",
    "guild_page_name": "Nama (Inggeris)",
    "guild_page_name_english": "Nama mesti dalam bahasa Inggeris",
    "guild_page_bank_number": "Nombor akaun bank",
    "guild_page_enter": "Masukkan nombor akaun bank yang betul",
    "guild_page_address": "Alamat (Inggeris)",
    "guild_page_address_english": "Alamat mesti dalam bahasa Inggeris",
    "guild_page_country": "Negara/Rantau",
    "guild_page_holder_name": "Nama pemegang akaun",
    "guild_page_sa": "Contoh: SA8200000000XXXXXXXXXXXX",
    "guild_page_format": "Format: Jalan, Kawasan, Bandar, Negeri, Negara",
    "guild_page_minimum": "3. Jumlah pengeluaran minimum ialah {n} Coins",
    "withdraw_input_amount": "Masukkan jumlah",
    "withdraw_submit": "Keluarkan wang",
    "withdraw_quantity": "Jumlah pengeluaran",
    "withdraw_actual_received": "Jumlah bersih diterima",
    "common_confirm": "Sahkan",
    "common_cancel": "Batal",
    "withdraw_error_min_amount": "Belum capai minimum pengeluaran",
    "withdraw_error_max_amount": "Melebihi had maksimum pengeluaran",
    "withdraw_error_max_p_coin": "Melebihi syiling tersedia untuk pengeluaran",
    "guild_can_with_usd": "Boleh dikeluarkan (≈USD {n})",
    "guild_pending_settlement": "Menunggu penyelesaian",
    "guild_funds_operation": "Operasi Dana",
    "guild_withdrawable_amount_title": "Jumlah Boleh Dikeluarkan",
    "guild_withdrawable_amount_tip1": "1. Bagi memastikan keselamatan dana dan mengurangkan risiko keselamatan, sistem akan menjalankan semakan kawalan risiko ke atas setiap pendapatan coins. Sepanjang tempoh semakan, coins akan berada dalam status 'Menunggu Penyelesaian'.",
    "guild_withdrawable_amount_tip2": "2. Semakan akan diselesaikan selewat-lewatnya dalam {s} jam. Jika diluluskan, coins akan dipindahkan daripada 'Menunggu Penyata' ke 'Boleh Dikeluarkan'; jika tidak diluluskan, sistem akan memproses mengikut peraturan.",
    "guild_withdrawable_amount_tip3": "3. Dalam situasi khas seperti kegagalan pengeluaran atau pemulangan, anda boleh membuat pengeluaran serta-merta.",
    "guild_got_it": "Faham",
    "guild_pending_settlement_detail": "Butiran penyelesaian tertunda",
    "guild_pending_settlement_tip": "Pendapatan syiling emas akan menjadi 'jumlah boleh dikeluarkan' selepas penyelesaian selamat selesai dan dijangka masuk ke baki boleh dikeluarkan selewat-lewatnya dalam {s} jam.",
    "guild_pending_settlement_amount": "Amaun Penyelesaian Tertunda",
    "guild_pending_settlement_last_30_days": "Hanya memaparkan rekod bagi {n} jam yang lalu",
    "guild_pending_settlement_list_tips": "Hanya pendapatan tertunda dalam {n} jam terakhir akan dipaparkan. Jumlah yang telah digunakan atau ditolak tidak akan dipaparkan di sini. Anda boleh pergi ke",
    "guild_pending_settlement_list_tips_btn": "Halaman Rekod Coins",
    "guild_pending_settlement_list_tips_look": "Lihat",
    "guild_pending_stamp_settled": "Telah diselesaikan",
    "guild_pending_stamp_used": "Telah digunakan",
    "guild_pending_stamp_deducted": "Telah ditolak",
    "guild_record_guild_reward": "Ganjaran agensi",
    "guild_record_gift": "Menerima hadiah",
    "guild_order_id": "ID Pesanan",
    "guild_withdraw_record_total": "Jumlah {s} transaksi",
    "guild_status_reseller_review": "reseller sedang disemak",
    "guild_status_security_review": "Semakan keselamatan",
    "guild_select_withdraw_amount": "Pilih jumlah pengeluaran",
    "guild_reference_fee": "Caj perkhidmatan",
    "guild_change_channel": "Tukar",
    "guild_change_channel_title": "Tukar saluran",
    "guild_current_can_withdraw": "Boleh dikeluarkan sekarang",
    "guild_confirm_bind": "Sahkan Pengikatan",
    "guild_bind_notice_title": "Petunjuk",
    "guild_bind_tip_1": "Nama mesti sepadan dengan pengesahan nama sebenar akaun.",
    "guild_bind_tip_2": "Maklumat akaun yang salah boleh menyebabkan pengeluaran gagal dan wang tidak dapat dimasukkan. Sila semak setiap maklumat dengan teliti sebelum menghantar.",
    "guild_confirm_withdraw_info": "Sahkan maklumat pengeluaran",
    "guild_withdraw_amount_label": "Amaun pengeluaran",
    "guild_estimated_arrival_time": "Anggaran masa ketibaan",
    "guild_confirm_info_tip": "Sila semak maklumat pengeluaran dengan teliti. Jika terdapat sebarang kesilapan, pesanan tersebut tidak akan dikreditkan.",
    "guild_modify": "Edit",
    "guild_confirm_submit": "Sahkan penghantaran",
    "guild_withdraw_success_tip": "Wang dijangka akan diterima dalam {s} hari bekerja. Sila tunggu dengan sabar. Anda boleh ke [Halaman Pengeluaran] - bahagian kanan atas [Rekod Pengeluaran] untuk semak status.",
    "guild_name": "Nama",
    "guild_bank_account": "Akaun Bank",
    "guild_please_enter": "Sila masukkan",
    "guild_withdraw_submit_success": "Penghantaran berjaya",
    "guild_withdraw_success_tip2": "Dana dijangka dikreditkan dalam masa {s} hari bekerja. Sila tunggu dengan sabar. Anda boleh semak kemajuan di [Halaman Pengeluaran] - penjuru kanan atas [Rekod Pengeluaran].",
    "guild_platform_settlement_success_tip": "Pembayaran akan diproses secara serentak pada hari Isnin depan. Sila bersabar. Anda boleh semak kemajuan dengan pergi ke [Halaman Pengeluaran] dan klik [Rekod Pengeluaran] di sebelah kanan atas.",
    "guild_transfer_to_reseller": "Pindahkan kepada pengedar",
    "guild_transfer_to_reseller_label": "Pindahkan ke RESELLER",
    "guild_reseller_confirm_desc": "Sila sahkan dengan RESELLER tentang urusan pembayaran. Selepas anda klik 'Sahkan', anda akan ditolak",
    "guild_reseller_confirm_tip_1": "1. Sila berhubung dengan reseller lebih awal mengenai urusan pembayaran luar talian.",
    "guild_reseller_confirm_tip_2": "2. Jika pihak lain menolak, syiling anda akan dikembalikan secara automatik;",
    "guild_reseller_confirm_tip_3": "3. Jumlah pengeluaran minimum ialah {n} syiling.",
    "guild_leader_settle_subtitle": "Ketua agensi akan selesaikan dengan anda di luar talian",
    "guild_leader_confirm_desc": "Sila pastikan anda telah berbincang tentang urusan pembayaran dengan ketua agensi. Apabila anda klik 'Sahkan', coin akan ditolak.",
    "guild_leader_confirm_tip_1": "1. Operasi ini akan menghantar permohonan kepada ketua agensi, dan ketua agensi akan membuat pembayaran kepada anda secara luar talian;",
    "guild_leader_confirm_tip_2": "2. Sila sahkan kaedah pembayaran (kad bank/USDT dan sebagainya) dengan ketua agency terlebih dahulu; jika ketua agency menolak, coins anda akan dipulangkan secara automatik;",
    "guild_leader_confirm_tip_3": "3. Jumlah pengeluaran minimum adalah {n} syiling;",
    "guild_leader_confirm_tip_4": "4. Jika ketua agensi mengesahkan pembayaran telah dibuat tetapi anda masih belum menerima wang, sila simpan rekod perbualan dan buat aduan kepada platform.",
    "guild_leader_confirm_tip_4_prefix": "5. Jika ketua agensi mengesahkan pembayaran telah dibuat tetapi anda belum menerima wang, sila simpan rekod sembang dan buat aduan kepada platform.",
    "guild_leader_platform_appeal": "Buat rayuan kepada platform",
    "pixNamePlaceholder": "Masukkan nama pengguna pix",
    "pixIdType": "Jenis ID",
    "transfer": {
        "bindSuccess": "Berjaya menghubungkan",
        "error": "Operasi gagal, sila cuba lagi kemudian."
    },
    "pixSelectIdTypePlaceholder": "Pilih jenis ID",
    "pixIdPlaceholder": "Masukkan {s} anda",
    "pixSelectAccountTypePlaceholder": "Pilih jenis akaun pix",
    "pixAccountPlaceholder": "Masukkan {s} anda",
    "whatsAppIdPlaceholder": "Masukkan ID WhatsApp anda",
    "pixCpfLengthError": "CPF mesti mempunyai 11 digit",
    "pixCnpjLengthError": "CNPJ mesti mempunyai 14 digit",
    "pixCpfNotMatchError": "Dua kali CPF yang diisi tidak sama",
    "pixCnpjNotMatchError": "Dua CNPJ yang dimasukkan tidak sepadan",
    "pixFormatError": "Ralat format",
    "notFilled": "{s} belum diisi",
    "formatErrorCheck": "Ralat format, sila semak.",
    "certi_tips": "Petua",
    "certi_tips1": "Untuk melindungi keselamatan akaun dan mengurangkan risiko serangan jenayah, anda perlu melengkapkan pengesahan sebelum meneruskan. Sila pergi ke ‘Saya’ > ‘Pusat Pengesahan’ dalam aplikasi untuk melengkapkan pengesahan sebelum meneruskan operasi.",
    "certi_tips2": "Pergi untuk sahkan",
    "certi_tips3": "Versi semasa terlalu lama. Sila naik taraf dan cuba lagi.",
    "certi_tips4": "Bagi melindungi keselamatan akaun dan mengurangkan risiko serangan haram, pengesahan perlu diselesaikan untuk meneruskan operasi.",
    "ff": "Roket Berlepas! Cabar Pengganda Tinggi!",
    "dd": "Berlepas Sekarang",
    "guild_country": "Negara/Wilayah",
    "guild_bank_name": "Bank",
    "guild_iban": "IBAN",
    "guild_whatsapp": "WhatsApp",
    "guild_document_type": "Jenis Pengenalan",
    "guild_document_id": "Nombor Pengenalan",
    "guild_account_type": "Jenis Akaun",
    "guild_address": "Alamat",
    "guild_settlement_weekly_process": "Diproses secara seragam setiap hari Isnin",
    "withdrawal_channel": "Saluran Pengeluaran",
    "guild_whatsapp_contact_tip": "Sila tinggalkan maklumat perhubungan anda, kami akan menghubungi anda melalui WhatsApp",
    "guild_bind": "Pautkan",
    "guild_settlement_input_amount": "Masukkan jumlah pengeluaran",
    "gift_sphinx6": "Piramid",
    "gift_sphinx7": "Menara Monas",
    "guild_no_more_data": "Tiada lagi kandungan",
    "guild_bind_channel_toast": "Sila pautkan maklumat saluran terlebih dahulu"
}
